var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-card',{attrs:{"title":"Mail Work Orders","icon":"fas fa-mail-bulk","is-date-range":"","loading":_vm.loading},on:{"import":_vm.importEvent,"export":_vm.exportEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }